if (!customElements.get('card-testimonial')) {
  class CardTestimonial extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.quote = this.querySelector('[data-quote]');

      this.setHeight();

      window.addEventListener('resize', this.setHeight.bind(this));
    }

    setHeight() {
      if (!this.quote) {
        return;
      }

      this.quote.style.removeProperty('--max-height');
      this.quote.style.setProperty(
        '--max-height',
        `${this.quote.offsetHeight}px`,
      );
    }
  }
  customElements.define('card-testimonial', CardTestimonial);
}
